import React from "react";
import { Gratuity, GratuityReference, ReferenceObject } from "types";
import { NoTranslate } from "../../Common/NoTranslate";

export const GratuityItemName = ({ gratuity }: { gratuity: Gratuity }) => {
    const guideProfiles = gratuity.references.filter((ref: GratuityReference) => {
        return ref.object === ReferenceObject.USER_PROFILE;
    });

    if (guideProfiles && guideProfiles.length > 0) {
        const guideNames = guideProfiles.map((ref: GratuityReference) => ref.name);
        return <NoTranslate>{guideNames.join(",")}</NoTranslate>;
    }

    return <>-</>;
};
